import React, { Component } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBIcon
} from "mdbreact";
import axios from "axios";
import API_URL from "./../config";
import logo1 from "./LogoRemuneraciones.png";

class RecuperarContrasena extends Component {
  state = {
    usuario: "",
    correo: "",
    mensaje: "",
    tipoMensaje: "",
    cargando: false
  };

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value, mensaje: "", tipoMensaje: "" });
  }

  acceder = async (event) => {
    event.preventDefault();

    if (!this.state.usuario || !this.state.correo) {
      this.setState({ mensaje: "Debe completar ambos campos", tipoMensaje: "error" });
      return;
    }

    this.setState({ cargando: true, mensaje: "", tipoMensaje: "" });

    try {
      const response = await axios.post(`${API_URL}/validardatos/`, {
        method: "post",
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          usuario: this.state.usuario,
          correo: this.state.correo
        })
      });

      if (response.data && response.data.length > 0) {
        if (response.data[0].valido === "true") {
          this.setState({
            mensaje: response.data[0].informacion,
            tipoMensaje: "exito",
            usuario: "",
            correo: ""
          });
        } else {
          this.setState({
            mensaje: response.data[0].informacion,
            tipoMensaje: "error"
          });
        }
      } else {
        this.setState({ mensaje: "No se recibió respuesta del servidor", tipoMensaje: "error" });
      }
    } catch (error) {
      this.setState({
        mensaje: "Error de conexión con el servidor",
        tipoMensaje: "error"
      });
    }

    this.setState({ cargando: false });
  };

  render() {
    const { mensaje, tipoMensaje, cargando } = this.state;

    return (
      <MDBContainer className="mt-5 pt-4">
        <MDBRow center>
          <MDBCol md="6" lg="5">
            <MDBCard>
              <MDBCardBody className="px-4 py-4">
                <div className="text-center mb-3">
                  <img
                    src={logo1}
                    alt="Logo Remuneraciones"
                    style={{ width: "100px", height: "100px", objectFit: "contain", borderRadius: "50%" }}
                  />
                  <h5 className="mt-3 font-weight-bold" style={{ color: "#7A1622" }}>
                    Recuperar Contraseña
                  </h5>
                  <p className="text-muted mb-0" style={{ fontSize: "0.85rem" }}>
                    Ingrese sus datos para generar una nueva contraseña
                  </p>
                </div>

                <hr />

                {mensaje && (
                  <div
                    className="text-center py-2 px-3 mb-3"
                    style={{
                      backgroundColor: tipoMensaje === "exito" ? "#d4edda" : "#f8d7da",
                      color: tipoMensaje === "exito" ? "#155724" : "#721c24",
                      borderRadius: "6px",
                      border: `1px solid ${tipoMensaje === "exito" ? "#c3e6cb" : "#f5c6cb"}`,
                      fontSize: "0.9rem"
                    }}
                  >
                    <MDBIcon
                      icon={tipoMensaje === "exito" ? "check-circle" : "exclamation-circle"}
                      className="mr-2"
                    />
                    {mensaje}
                  </div>
                )}

                <form onSubmit={this.acceder}>
                  <MDBInput
                    label="Número de DNI"
                    icon="id-card"
                    group
                    validate
                    error="wrong"
                    success="right"
                    value={this.state.usuario}
                    onChange={this.onChange.bind(this)}
                    name="usuario"
                    id="usuario"
                    type="text"
                  />
                  <MDBInput
                    label="Correo institucional"
                    icon="envelope"
                    group
                    validate
                    error="wrong"
                    success="right"
                    value={this.state.correo}
                    onChange={this.onChange.bind(this)}
                    name="correo"
                    id="correo"
                    type="email"
                  />

                  <div className="text-center mt-3">
                    <MDBBtn
                      type="submit"
                      style={{ backgroundColor: "#7A1622", borderRadius: "20px" }}
                      className="btn-block"
                      disabled={cargando}
                    >
                      {cargando ? (
                        <span>
                          <MDBIcon icon="spinner" spin className="mr-2" />
                          Validando...
                        </span>
                      ) : (
                        <span>
                          <MDBIcon icon="paper-plane" className="mr-2" />
                          Solicitar Contraseña
                        </span>
                      )}
                    </MDBBtn>
                  </div>

                  <div className="text-center mt-3">
                    <a
                      href="/"
                      style={{ fontSize: "0.88rem", color: "#7A1622", fontWeight: "500", textDecoration: "none" }}
                      onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
                      onMouseLeave={(e) => e.target.style.textDecoration = "none"}
                    >
                      <MDBIcon icon="arrow-left" className="mr-1" size="sm" />
                      Volver al inicio de sesión
                    </a>
                  </div>
                </form>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    );
  }
}

export default RecuperarContrasena;
